import { Card, CardHeader, CardProps } from '@mui/material';
import { ReactNode } from 'react';
import { MHMTypography } from '../MHM/MHMTypography';

type Props = CardProps & {
  title: ReactNode;
  children: ReactNode;
};

export function SettingsCard({ title, children, ...rest }: Props) {
  return (
    <Card variant="outlined" {...rest}>
      <CardHeader
        title={
          <MHMTypography variant="h5" component="h2" bold>
            {title}
          </MHMTypography>
        }
        sx={{
          py: 1,
          bgcolor: 'highlightedBackground.main',
          borderBottom: '1px solid',
          borderColor: 'lightgrey',
          borderRadius: '5px 5px 0 0',
        }}
      />
      {children}
    </Card>
  );
}
